/**
 * Created by Jerker Nord on 2021-01-27.
 */
import { AssetQualityLevel, IResourcesGroupConfig } from "@nolimitcity/slot-game/bin/asset/Asset";
import { BitmapFontAsset } from "@nolimitcity/slot-game/bin/asset/assettypes/BitmapFontAsset";
import { SpineAsset } from "@nolimitcity/slot-game/bin/asset/assettypes/SpineAsset";
import { TextureAsset } from "@nolimitcity/slot-game/bin/asset/assettypes/TextureAsset";

import { UCFontsNames, UCSpineNames } from "./UCAssetsNames";

export class UCAssetsLoader {
    public static RESOURCES_GROUPS: IResourcesGroupConfig = {
        intro: [],

        main: [
            {
                name: `fonts`,
                assets: [
                    new BitmapFontAsset(UCFontsNames.UC_DEFAULT, `fonts/bitmapfonts/UCWinFont.fnt`),
                    new BitmapFontAsset(UCFontsNames.UC_WAYS, `fonts/bitmapfonts/UCWaysFont.fnt`),
                    new BitmapFontAsset(
                        UCFontsNames.UC_MULTIPLIER,
                        `fonts/bitmapfonts/UCMultiplierFont.fnt`
                    ),
                ],
            },
            {
                name: `backgrounds`,
                autoLoad: [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets: [
                    new TextureAsset(`backgrounds0`, `sheets/backgrounds/backgrounds0.json`),
                    new TextureAsset(`backgrounds1`, `sheets/backgrounds/backgrounds1.json`),
                    new TextureAsset(`backgrounds2`, `sheets/backgrounds/backgrounds2.json`),
                ],
            },
            {
                name: `main`,
                assets: [
                    new TextureAsset(`main0`, `sheets/main/main0.json`),
                    new TextureAsset(`main1`, `sheets/main/main1.json`),
                    // new TextureAsset(`main2`, `sheets/main/main2.json`),
                    // new TextureAsset(`main3`, `sheets/main/main3.json`),
                ],
            },
            {
                name: `bigwins`,
                assets: [
                    new TextureAsset(`bigWin0`, `sheets/bigwins/bigwins0.json`),
                    new TextureAsset(`bigWin1`, `sheets/bigwins/bigwins1.json`),
                    new TextureAsset(`bigWin2`, `sheets/bigwins/bigwins2.json`),
                    new TextureAsset(`bigWin3`, `sheets/bigwins/bigwins3.json`),
                ],
            },
            {
                name: `mainJpeg`,
                assets: [
                    new TextureAsset(`mainJpeg0`, `sheets/mainJpeg/mainJpeg0.json`),
                    new TextureAsset(`mainJpeg1`, `sheets/mainJpeg/mainJpeg1.json`),
                ],
            },
            // {
            //     name: `numbers`,
            //     assets: [
            //         new TextureAsset(`numbers0`, `sheets/numbers/numbers0.json`),
            //         new TextureAsset(`numbers1`, `sheets/numbers/numbers1.json`),
            //     ],
            // },
            {
                name: `symbols`,
                autoLoad: [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets: [
                    new TextureAsset(`symbols0`, `sheets/symbols/symbols0.json`),
                    new TextureAsset(`symbols1`, `sheets/symbols/symbols1.json`),
                    // new TextureAsset(`symbols2`, `sheets/symbols/symbols2.json`),
                    // new TextureAsset(`symbols3`, `sheets/symbols/symbols3.json`),
                    // new TextureAsset(`symbols4`, `sheets/symbols/symbols4.json`),
                ],
                animations: {},
            },
            {
                name: `reels`,
                assets: [
                    new TextureAsset(`reels0`, `sheets/reels/reels0.json`),
                    new TextureAsset(`reels1`, `sheets/reels/reels1.json`),
                ],
                animations: {},
            },
            {
                name: `freespins`,
                assets: [
                    new TextureAsset(`freespins0`, `sheets/introOutro/introOutro0.json`),
                    new TextureAsset(`freespins1`, `sheets/introOutro/introOutro1.json`),
                ],
                animations: {},
            },
            {
                name: `spine`,
                assets: [
                    new SpineAsset(UCSpineNames.ANTICIPATION, UCSpineNames.ANTICIPATION),
                    // new SpineAsset(UCSpineNames.XBET, UCSpineNames.XBET),
                    new SpineAsset(
                        UCSpineNames.FS_BOAT_MULTIPLIER,
                        UCSpineNames.FS_BOAT_MULTIPLIER
                    ),
                    new SpineAsset(
                        UCSpineNames.FS_FISH_1_6_BOARDS,
                        UCSpineNames.FS_FISH_1_6_BOARDS
                    ),
                    new SpineAsset(
                        UCSpineNames.FISH_TO_BOAT_MULTIPLIER,
                        UCSpineNames.FISH_TO_BOAT_MULTIPLIER
                    ),
                    new SpineAsset(
                        UCSpineNames.BOAT_TO_WILD_MULTIPLIER,
                        UCSpineNames.BOAT_TO_WILD_MULTIPLIER
                    ),
                    new SpineAsset(UCSpineNames.FS_FISH_7_BOARD, UCSpineNames.FS_FISH_7_BOARD),
                    new SpineAsset(UCSpineNames.M1, UCSpineNames.M1),
                    new SpineAsset(UCSpineNames.M2, UCSpineNames.M2),
                    new SpineAsset(UCSpineNames.M3, UCSpineNames.M3),
                    new SpineAsset(UCSpineNames.M5, UCSpineNames.M5),
                    new SpineAsset(UCSpineNames.L1, UCSpineNames.L1),
                    new SpineAsset(UCSpineNames.L2, UCSpineNames.L2),
                    new SpineAsset(UCSpineNames.L3, UCSpineNames.L3),
                    new SpineAsset(UCSpineNames.L4, UCSpineNames.L4),
                    new SpineAsset(UCSpineNames.L5, UCSpineNames.L5),
                    new SpineAsset(UCSpineNames.F1, UCSpineNames.F1),
                    new SpineAsset(UCSpineNames.F2, UCSpineNames.F2),
                    new SpineAsset(UCSpineNames.F3, UCSpineNames.F3),
                    new SpineAsset(UCSpineNames.F4, UCSpineNames.F4),
                    new SpineAsset(UCSpineNames.F5, UCSpineNames.F5),
                    new SpineAsset(UCSpineNames.F6, UCSpineNames.F6),
                    new SpineAsset(UCSpineNames.F7, UCSpineNames.F7),
                    new SpineAsset(UCSpineNames.BIG_FISH, UCSpineNames.BIG_FISH),
                    new SpineAsset(UCSpineNames.MYSTERY, UCSpineNames.MYSTERY),
                    new SpineAsset(UCSpineNames.SCATTER, UCSpineNames.SCATTER),
                    new SpineAsset(UCSpineNames.SILVER_WILD, UCSpineNames.SILVER_WILD),
                    new SpineAsset(UCSpineNames.GOLD_WILD, UCSpineNames.GOLD_WILD),
                    new SpineAsset(UCSpineNames.WIN_FRAME, UCSpineNames.WIN_FRAME),
                    new SpineAsset(UCSpineNames.REEL_BLOCKER, UCSpineNames.REEL_BLOCKER),
                    new SpineAsset(
                        UCSpineNames.REEL_BLOCKER_ANTICIPATION,
                        UCSpineNames.REEL_BLOCKER_ANTICIPATION
                    ),
                    new SpineAsset(UCSpineNames.BIG_WIN_1, UCSpineNames.BIG_WIN_1),
                    new SpineAsset(UCSpineNames.BIG_WIN_2, UCSpineNames.BIG_WIN_2),
                    new SpineAsset(UCSpineNames.BIG_WIN_3, UCSpineNames.BIG_WIN_3),
                    new SpineAsset(UCSpineNames.BIG_WIN_4, UCSpineNames.BIG_WIN_4),
                    new SpineAsset(UCSpineNames.BIG_WIN_5, UCSpineNames.BIG_WIN_5),
                    new SpineAsset(UCSpineNames.MAX_CAP_WIN, UCSpineNames.MAX_CAP_WIN),
                    new SpineAsset(UCSpineNames.FS_INTRO, UCSpineNames.FS_INTRO),
                    new SpineAsset(UCSpineNames.SFS_INTRO, UCSpineNames.SFS_INTRO),
                    new SpineAsset(UCSpineNames.REEL_SEPARATORS, UCSpineNames.REEL_SEPARATORS),
                    new SpineAsset(UCSpineNames.BEER_CAN, UCSpineNames.BEER_CAN),
                    new SpineAsset(
                        UCSpineNames.BACKGROUND_BUBBLES,
                        UCSpineNames.BACKGROUND_BUBBLES
                    ),
                    new SpineAsset(UCSpineNames.BACKGROUND_FISHES, UCSpineNames.BACKGROUND_FISHES),
                    new SpineAsset(
                        UCSpineNames.BOAT_MULTIPLIER_PARTICLES,
                        UCSpineNames.BOAT_MULTIPLIER_PARTICLES
                    ),
                ],
            },
        ],
    };
}
